import {addDoc, collection, serverTimestamp} from 'firebase/firestore';
import {db} from './firebase';

// tracking simplu: fiecare eveniment e un document in trackingUsers (count = query length)
// nu blocam niciodata experienta userului daca tracking-ul esueaza
const trackEvent = async (type, extra = {}) => {
    try {
        await addDoc(collection(db, 'trackingUsers'), {
            type,
            timestamp: serverTimestamp(),
            ...extra,
        });
    } catch (err) {
        console.error('tracking error', err);
    }
};

export const trackRegisterButtonClick = () => trackEvent('register_button_click');

export const trackRegisterSubmitError = (error, email) => trackEvent('register_submit_error', {
    errorCode: error?.code || 'unknown',
    errorMessage: error?.message || String(error),
    email: email || '',
});
